export default {
  'language.usd': 'Dollar',
  'language.rub': 'Rubl',
  'language.eur': 'Euro',
  'language.yen': 'Yen',
  'language.german': 'Deutsche',
  'language.italian': 'Italiano',
  'language.arabic': 'عربی',
  'language.french': 'Français',
  'language.spanish': 'Español',
  'language.russian': 'русский',
  'language.english': 'English',
  'language.iran': 'فارسی',
  'language.japanese': 'Japanisch',
  'language.rial': 'Rial',
  'language.persian': 'Persisch',
  'component.select': 'Wählen',
  'form.requierd': 'erforderlich',
  'form.isshort': 'zu kurz',
  'form.islong': 'zu lang',
  'form.invalid': 'ungültig',
  'form.number': 'muss eine Nummer sein',
  'alert.info': 'Info',
  'alert.warning': 'Achtung',
  'alert.error': 'Erro',
  'alert.notitle': ' ',
  'alert.success': 'Erfolg',
  'errorBoundary.oops': 'Hoppla!!',
  'errorBoundary.weSearched': 'Die gewünschte Seite wurde nicht gefunden.',
  'errorBoundary.backToHome': 'Zurück nach Hause',
  'error.receiveerror': 'Fehler beim Empfang der Informationen',
  NextStep: 'Nächster Schritt',
  Previous: 'Bisherige / letzte',
  FirstName: 'Vorname',
  LastName: 'Nachname',
  BirthDate: 'Geburtsdatum',
  NationalCode: '	Ausweiscode',
  Yes: 'ja',
  No: 'nein',
  Jalali: 'Jalali-Kalender',
  Miladi: 'Gregorianischer Kalender',
  Hijri: 'Islamischer Kalender',
};
